import { render } from "./LbrxWelcomeInterface.vue?vue&type=template&id=3ebf3580&scoped=true"
import script from "./LbrxWelcomeInterface.vue?vue&type=script&lang=js"
export * from "./LbrxWelcomeInterface.vue?vue&type=script&lang=js"

import "./LbrxWelcomeInterface.vue?vue&type=style&index=0&id=3ebf3580&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ebf3580"]])

export default __exports__